var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelojCircular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_cigarrillo_lineal_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.14,
    height: 65.14,
    viewBox: "0 0 65.14 65.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1557",
    "data-name": "Elipse 1557",
    cx: 31.616,
    cy: 31.616,
    r: 31.616,
    transform: "translate(0.954 0.954)",
    fill: "#fc287e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1558",
    "data-name": "Elipse 1558",
    cx: 26.517,
    cy: 26.517,
    r: 26.517,
    transform: "translate(6.053 6.053)",
    fill: "#fce3ed"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1561",
    "data-name": "Elipse 1561",
    cx: 2.039,
    cy: 2.039,
    r: 2.039,
    transform: "translate(30.531 30.531)",
    fill: "#fc287e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104990",
    "data-name": "Trazado 104990",
    d: "M55.6,9.539A32.57,32.57,0,0,0,9.539,55.6,32.57,32.57,0,0,0,55.6,9.539ZM54.251,54.251A30.662,30.662,0,0,1,10.889,10.889,30.662,30.662,0,0,1,54.251,54.251Z",
    fill: "#3b0310"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104991",
    "data-name": "Trazado 104991",
    d: "M42,66.63A25.564,25.564,0,0,1,84.18,48.135a.954.954,0,1,0,1.243-1.448A27.472,27.472,0,0,0,46.688,85.424a.954.954,0,1,0,1.448-1.243A25.466,25.466,0,0,1,42,66.63Z",
    transform: "translate(-34.979 -34.979)",
    fill: "#3b0310"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104992",
    "data-name": "Trazado 104992",
    d: "M151.955,113.222a.954.954,0,0,0-1.448,1.243,25.564,25.564,0,0,1-36.046,36.045.954.954,0,0,0-1.243,1.448,27.352,27.352,0,0,0,17.867,6.61c.331,0,.664-.006,1-.018a27.472,27.472,0,0,0,19.874-45.328Z",
    transform: "translate(-98.524 -98.527)",
    fill: "#3b0310"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104993",
    "data-name": "Trazado 104993",
    d: "M249.454,77.114a.954.954,0,0,0,.954-.954V73.1a.954.954,0,1,0-1.908,0v3.06A.954.954,0,0,0,249.454,77.114Z",
    transform: "translate(-216.884 -62.967)",
    fill: "#3b0310"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104994",
    "data-name": "Trazado 104994",
    d: "M249.454,400.807a.954.954,0,0,0-.954.954v3.06a.954.954,0,0,0,1.908,0v-3.06A.954.954,0,0,0,249.454,400.807Z",
    transform: "translate(-216.884 -349.814)",
    fill: "#3b0310"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104995",
    "data-name": "Trazado 104995",
    d: "M405.775,249.454a.954.954,0,0,0-.954-.954h-3.06a.954.954,0,1,0,0,1.908h3.06A.954.954,0,0,0,405.775,249.454Z",
    transform: "translate(-349.814 -216.884)",
    fill: "#3b0310"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104996",
    "data-name": "Trazado 104996",
    d: "M73.1,248.5a.954.954,0,1,0,0,1.908h3.06a.954.954,0,1,0,0-1.908Z",
    transform: "translate(-62.966 -216.884)",
    fill: "#3b0310"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104997",
    "data-name": "Trazado 104997",
    d: "M98.492,163.25a.954.954,0,0,0,.478-1.781l-1.766-1.02a.954.954,0,0,0-.954,1.653l1.766,1.02A.95.95,0,0,0,98.492,163.25Z",
    transform: "translate(-83.587 -139.924)",
    fill: "#3b0310"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104998",
    "data-name": "Trazado 104998",
    d: "M388.773,328.788a.954.954,0,0,0-.954,1.653l1.766,1.02a.954.954,0,1,0,.954-1.653Z",
    transform: "translate(-338.062 -286.846)",
    fill: "#3b0310"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104999",
    "data-name": "Trazado 104999",
    d: "M329.613,99.446a.954.954,0,0,0,.827-.477l1.02-1.766a.954.954,0,0,0-1.653-.954l-1.02,1.766a.954.954,0,0,0,.825,1.431Z",
    transform: "translate(-286.846 -83.587)",
    fill: "#3b0310"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105000",
    "data-name": "Trazado 105000",
    d: "M162.773,387.47a.954.954,0,0,0-1.3.349l-1.02,1.766a.954.954,0,1,0,1.653.954l1.02-1.766A.954.954,0,0,0,162.773,387.47Z",
    transform: "translate(-139.925 -338.062)",
    fill: "#3b0310"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105001",
    "data-name": "Trazado 105001",
    d: "M389.587,160.449l-1.766,1.02a.954.954,0,1,0,.954,1.653l1.766-1.02a.954.954,0,0,0-.954-1.653Z",
    transform: "translate(-338.063 -139.924)",
    fill: "#3b0310"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105002",
    "data-name": "Trazado 105002",
    d: "M99.319,329.138a.954.954,0,0,0-1.3-.349l-1.766,1.02a.954.954,0,1,0,.954,1.653l1.766-1.02A.954.954,0,0,0,99.319,329.138Z",
    transform: "translate(-83.587 -286.846)",
    fill: "#3b0310"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105003",
    "data-name": "Trazado 105003",
    d: "M163.122,98.014l-1.02-1.766a.954.954,0,1,0-1.653.954l1.02,1.766a.954.954,0,0,0,1.653-.954Z",
    transform: "translate(-139.925 -83.586)",
    fill: "#3b0310"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105004",
    "data-name": "Trazado 105004",
    d: "M329.137,387.47a.954.954,0,0,0-.349,1.3l1.02,1.766a.954.954,0,1,0,1.653-.954l-1.02-1.766A.954.954,0,0,0,329.137,387.47Z",
    transform: "translate(-286.846 -338.062)",
    fill: "#3b0310"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105005",
    "data-name": "Trazado 105005",
    d: "M235.681,144.51a.954.954,0,0,0-.954-.954H224.306a3.007,3.007,0,0,0-1.883-1.883V129.212a.954.954,0,1,0-1.908,0v12.461a3.007,3.007,0,0,0-1.883,1.883h-1.242a.954.954,0,0,0,0,1.908h1.242a3.007,3.007,0,0,0,1.883,1.883v1.242a.954.954,0,1,0,1.908,0v-1.242a3.007,3.007,0,0,0,1.883-1.883h10.421A.954.954,0,0,0,235.681,144.51ZM221.469,145.6a1.085,1.085,0,1,1,1.085-1.085A1.087,1.087,0,0,1,221.469,145.6Z",
    transform: "translate(-188.899 -111.94)",
    fill: "#3b0310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelojCircular);
export default __webpack_public_path__ + "static/media/reloj-circular.64271093c1a39e04b8d614e897d6aa19.svg";
export { ForwardRef as ReactComponent };